var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AttendeeChangeType } from "@brushfire/types";
import { Alert } from "@brushfire/ui";
import moment from "moment";
import { FormattedDate, FormattedTime } from "react-intl";
var NoChangesAfterMessage = function (_a) {
    var changesAreBlocked = _a.changesAreBlocked, changesAreBlockedAfter = _a.changesAreBlockedAfter, attendeeChange = _a.attendeeChange, hasUnpaidInvoice = _a.hasUnpaidInvoice, hideAlert = _a.hideAlert;
    if (!hideAlert) {
        if (changesAreBlockedAfter && changesAreBlocked) {
            return (_jsx(Alert, __assign({ purpose: "info" }, { children: _jsxs("p", __assign({ className: "m-bottom-0" }, { children: ["No changes are allowed online after", " ", _jsx(FormattedDate, { value: moment.utc(changesAreBlockedAfter).toDate(), year: "numeric", month: "long", day: "numeric", weekday: "long" }), " ", _jsx(FormattedTime, { value: moment.utc(changesAreBlockedAfter).toDate(), hour12: true }), "."] })) })));
        }
        else if (changesAreBlockedAfter && !changesAreBlocked) {
            if (!!attendeeChange) {
                return (_jsxs(Alert, __assign({ purpose: "info" }, { children: [_jsxs("p", __assign({ className: "m-bottom-0" }, { children: ["No changes will be allowed online after", " ", _jsx(FormattedDate, { value: moment.utc(changesAreBlockedAfter).toDate(), year: "numeric", month: "long", day: "numeric", weekday: "long" }), " ", _jsx(FormattedTime, { value: moment.utc(changesAreBlockedAfter).toDate(), hour12: true }), "."] })), _jsx("p", __assign({ className: "m-bottom-0" }, { children: attendeeChange === AttendeeChangeType.None
                                ? "Changes that result in a finanical difference are not allowed for this event."
                                : attendeeChange === AttendeeChangeType.Positive
                                    ? "Changes that result in a refund are not allowed for this event."
                                    : null }))] })));
            }
            else {
                return (_jsx(Alert, __assign({ purpose: "info" }, { children: _jsxs("p", __assign({ className: "m-bottom-0" }, { children: ["No changes will be allowed online after", " ", _jsx(FormattedDate, { value: moment.utc(changesAreBlockedAfter).toDate(), year: "numeric", month: "long", day: "numeric", weekday: "long" }), " ", _jsx(FormattedTime, { value: moment.utc(changesAreBlockedAfter).toDate(), hour12: true }), "."] })) })));
            }
        }
        else if (!!attendeeChange) {
            return (_jsx(Alert, __assign({ purpose: "info" }, { children: _jsx("p", __assign({ className: "m-bottom-0" }, { children: attendeeChange === AttendeeChangeType.None
                        ? "Changes that result in a finanical difference are not allowed for this event."
                        : attendeeChange === AttendeeChangeType.Positive
                            ? "Changes that result in a refund are not allowed for this event."
                            : null })) })));
        }
        else if (hasUnpaidInvoice) {
            return (_jsx(Alert, __assign({ purpose: "info" }, { children: _jsx("p", __assign({ className: "m-bottom-0" }, { children: "Unpaid Square Invoices cannot be refunded unless the refund is for the full amount." })) })));
        }
    }
    return null;
};
export default NoChangesAfterMessage;
